import Button from '@mui/material/Button';
import React from 'react';
import { Link } from 'react-router-dom';

import { EmptyTableView } from '@/components/atoms/EmptyTableView';
import { useTranslator } from '@/hooks/useTranslator';

export const NoCustomersView: React.FC = (): React.ReactElement => {
  const tr = useTranslator();

  return (
    <EmptyTableView title={tr('NO_CUSTOMERS_YET_TITLE')} message="">
      <Button component={Link} to="new" variant="contained" size="compact">
        {tr('ADD_NEW_CUSTOMER')}
      </Button>
    </EmptyTableView>
  );
};
